import { React, useEffect, useState, useContext } from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from '../../../../App';
import { API_URL } from '../../../../Constant';
// import { wagesIndexReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { generateWagesIndexReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { changeDateFormat } from "../../../../Custom/Custom";
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';

const WagesIndexReport = () => {

    const [years, setYears] = useState([]);
    const [yearName, setyearName] = useState('');
    const [months, setMonth] = useState(
      [{ value: "1", label: "APR-JUN" },
      { value: "2", label: "JUL-SEP" },
      { value: "3", label: "OCT-DEC" },
      { value: "4", label: "JAN-MAR" }]);
    const [monthName, setMonthName] = useState('');
    const [reportType, setReportType] = useState('');
    const token = useContext(MyContextProvider).token;
    const navigate = useNavigate();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  
    //Get all Years Data
    useEffect(() => { 
      //Years
    const fetchYears = async () => {
        const currentYear = new Date().getFullYear();
        const endYear = 2001;
        const yearsArray = [];
      for (let year = currentYear; year >= endYear; year--) {
          yearsArray.push(`${year}-${year + 1}`);
        }
  
        setYears(yearsArray);
  
      };
      fetchYears();
   }, []);
  
  
  
    const getQuarterLabel = (monthValue) => {
      const quarters = {
        "1": "APR-JUN",
        "2": "JUL-SEP",
        "3": "OCT-DEC",
        "4": "JAN-MAR"
      };
      return quarters[monthValue] || '';
    };
  
  
    const formatGrossValue = (value) => {
      if (value === 0) return '0.00';
      if (value === "NaN" ) return '';
      if (value === '' || value === null || value === 'null') return '0.00';
      return Number(value).toFixed(2);
      };
  
  
    //handle excel sheet ***************
    const handleGenerateExcel = () => {

      if (!reportType) {
        toast.error('Please select the report type.', messages.COLOR_RED);
        return;
      }
      if (!yearName) {
        toast.error('Please select the year.', messages.COLOR_RED);
        return;
      }
      if (!monthName) {
        toast.error('Please select the quarter.', messages.COLOR_RED);
        return;
      }
  
     showLoading(true);
     let postData = {
        "reportType": reportType,  // Use reportType as reportType
        "yearProduction": yearName, // Use yearName as yearProduction
        "quarter": monthName       // Use monthName as quarter
      };
  
      const sheetName = reportType === '1' ? 'Rural_Wages' : 'Urban_Wages';
      const heading = reportType === '1' ? 'Rural Wages' : 'Urban Wages';
      // POST request to API
      axios
        .post(`${API_URL}api/price/wagesIndexReport`, postData, config)
        .then((response) => {
        let reportData=response.data;
  
       if(reportData.status){
  
     // Handle success and generate the Excel file directly
          const ruralWageIndexDataResponse =reportData.data.GroupCodes;
          const listBean1DataResponse = reportData.data.listBean1;

          const quarterLabel = getQuarterLabel(monthName);
          let excelFileName = `${sheetName}_Index_Ending_${monthName}_${yearName.split("-")[0]}`;
          const excelObjectData = {
            fileName: excelFileName,
            reportType: "WageIndex",
            fileType: 'xls',
            sheetName: sheetName,
            // firstRowMergeCells: "A1:H1",
            // firstRowExportDate: `${sheetName} Index of U.P. quarter Ending ${quarterLabel} ${yearName.split("-")[0]}`,

            firstRowMergeCells: "A1:H1",
            firstRowExportDate: changeDateFormat(new Date()),
            secondRowMergeCells: "A2:H2",
            secondRowText: `${heading} Index of U.P. quarter Ending ${quarterLabel} ${yearName.split("-")[0]}`,

            headerEnglishColumns: [
              'ITEM/REGION','', 'Weight', 'Wage', 'Weight', 'Wage', 'Weight', 'Wage'
            ],  
  
          };
  
          const transformedData = ruralWageIndexDataResponse.map((item) => [
            item.region,
            item.abc || '',
            formatGrossValue(item.carpenterWeight),
            formatGrossValue(item.carpenterWages),
            formatGrossValue(item.masonWeight),
            formatGrossValue(item.masonWages),
            formatGrossValue(item.agriWeight),
            formatGrossValue(item.agriWages)
          ]);

          const additionalData = listBean1DataResponse.map((item) =>[
            item.Items,
            item.Item,
            '',
            formatGrossValue(item.western),
            formatGrossValue(item.central),
            formatGrossValue(item.eastarn),
            formatGrossValue(item.b_khand),
            formatGrossValue(item.up)
          ]);
        
          const indicesBaseRow = ['Indices Base : : Agriculture Year 2004-05=100', '', '','','','','',''];
          const itemsRegionsRow = ['Items/Regions', '', '','Western','Central','Eastarn','B. Khand','U.P.'];
          if (transformedData.length < 5) {
              while (transformedData.length < 5) {
                  transformedData.push(['', '', '', '', '', '', '', '']);
              }
          }
          transformedData[5] = indicesBaseRow;
          transformedData[6] = itemsRegionsRow;
          excelObjectData.excelRowData = [...transformedData,...additionalData]
          generateWagesIndexReport(excelObjectData);
          showLoading(false);
        }else{
          toast.error('Data is not found', messages.COLOR_RED);
        }
        }).catch((error) => {
          console.error('API Error:', error);
         }).finally(()=>{
          showLoading(false);
        });
    };
  
  
  
    const storedLanguage = localStorage.getItem('language');
  
  
    return (
      <>
  
      <ToastContainer />
      <GlobalLoading />
  
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
            <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.WAGE_INDEX_REPORT : priceTitle.en.WAGE_INDEX_REPORT }} />
            </h4>


            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>Report Type</label>
                  <select 
                    value={reportType} 
                    onChange={(e) => setReportType(e.target.value)} 
                    name="report_type" 
                    className="form-select"
                  >
                    <option value="" disabled>[-Select-]</option>
                    <option value="1">Rural</option>
                    <option value="2">Urban</option>
                  </select>
                </div>


              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Select Year</label>
                <select 
                 value={yearName} 
                 onChange={(e) => (setyearName(e.target.value))} 
                 name="year_name" 
                 className="form-select" 
                >
                  <option value="" disabled >Select Year</option>
                  {years.map((ele, index) => (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  ))}
  
                </select>
              </div>
  
  
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Select Quarter</label>
                   <select 
                    value={monthName} 
                    onChange={(e) => (setMonthName(e.target.value))} 
                    name="month_name" 
                    className="form-select"
                   >
                  <option value="" disabled>Select Quarter</option>
                  {months.map((quarter, i) => (
                    <option key={i} value={quarter.value}>
                      {quarter.label}
                    </option>
                  ))}
  
                </select>
  
              </div>
  
  
  
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button 
                 onClick={handleGenerateExcel} 
                 type="submit" 
                 className="btn btn_orange"
                >
                Search
              </button>
              </div>
            </div>
          </div>
        </div>
  
      </div>
  
    </>
    )
  }

export default WagesIndexReport